export const tabNameMap = {
  baseInfo: {
    submitName: 'saveBaseInfo',
    changeTabMessage: '您修改了基础设置但没有保存，是否需要保存基础设置并继续？',
    refName: 'baseInfoRef'
  },
  formDesign: {
    submitName: 'saveFormDesign',
    changeTabMessage: '您修改了表单设计但没有保存，是否需要保存表单设计并继续？',
    refName: 'formDesignRef'
  },
  processDesign: {
    submitName: 'saveProcessDesign',
    changeTabMessage: '您修改了流程设计但没有保存，是否需要保存流程设计并继续？',
    refName: 'processDesignRef'
  },
  advancedSettings: {
    submitName: 'saveAdvancedSettings',
    changeTabMessage: '您修改了高级设置但没有保存，是否需要保存高级设置并继续？',
    refName: 'advancedSettingRef'
  }
};
